var exports = {
  "WB": "PersonalNotesWelcomeSection.module__welcomeSection___Zk45dH",
  "H": "PersonalNotesWelcomeSection.module__avatarContainer___Zk45dH",
  "oJ": "PersonalNotesWelcomeSection.module__avatarBackground___Zk45dH",
  "my": "PersonalNotesWelcomeSection.module__avatar___Zk45dH",
  "DD": "PersonalNotesWelcomeSection.module__title___Zk45dH",
  "fF": "PersonalNotesWelcomeSection.module__dividerContainer___Zk45dH",
  "K8": "PersonalNotesWelcomeSection.module__dividerSvg___Zk45dH",
  "h_": "PersonalNotesWelcomeSection.module__description___Zk45dH",
};

module.exports = exports;
